import React from "react";

const features = [
  {
    icon: "fa-clock",
    title: "24/7 Availability",
    description:
      "Book cabs anytime with round-the-clock customer support and instant assistance for all your travel needs.",
    color: "#FF6B00",
  },
  {
    icon: "fa-car",
    title: "Well-Maintained Fleet",
    description:
      "Choose from sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and Mini Buses for every journey.",
    color: "#0D6EFD",
  },
  {
    icon: "fa-user-tie",
    title: "Professional Drivers",
    description:
      "Experienced and verified drivers ensure safe, comfortable, and reliable transportation.",
    color: "#28A745",
  },
  {
    icon: "fa-money-bill-wave",
    title: "Affordable Pricing",
    description:
      "Transparent pricing with no hidden charges, offering the best value for local and outstation travel.",
    color: "#DC3545",
  },
  {
    icon: "fa-plane",
    title: "Airport Transfers",
    description:
      "Timely airport pickup and drop services for Pune, Mumbai, and Navi Mumbai airports.",
    color: "#6F42C1",
  },
  {
    icon: "fa-route",
    title: "Outstation Travel",
    description:
      "Comfortable outstation cab services to Mumbai, Goa, Nashik, Shirdi, Lonavala, and more.",
    color: "#20C997",
  },
];

const WhyChooseShivaiTravels = () => {
  return (
    <section
      style={{
        
        background: "#f8fafc",
      }}
    >
      <div className="container">
        {/* Heading */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "60px",
          }}
        >
          <span
            style={{
              color: "#FF6B00",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Why Choose Us
          </span>

          <h2
            style={{
              fontSize: "42px",
              fontWeight: "700",
              color: "#1f2937",
              marginTop: "10px",
            }}
          >
            Why Choose Shivai Travels?
          </h2>

          <p
            style={{
              maxWidth: "700px",
              margin: "15px auto 0",
              color: "#6b7280",
              lineHeight: "1.8",
            }}
          >
            We provide reliable cab services, premium vehicle rentals,
            professional drivers, and affordable travel solutions for local,
            airport, and outstation journeys.
          </p>
        </div>

        {/* Cards */}
        <div className="row">
          {features.map((item, index) => (
            <div className="col-lg-4 col-md-6 mb-4" key={index}>
              <div
                style={{
                  background: "#fff",
                  padding: "35px",
                  borderRadius: "20px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  transition: "0.3s",
                }}
              >
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    background: item.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 25px",
                    color: "#fff",
                    fontSize: "30px",
                  }}
                >
                  <i className={`fa ${item.icon}`}></i>
                </div>

                <h4
                  style={{
                    fontSize: "22px",
                    fontWeight: "600",
                    marginBottom: "15px",
                    color: "#111827",
                  }}
                >
                  {item.title}
                </h4>

                <p
                  style={{
                    color: "#6b7280",
                    lineHeight: "1.8",
                    margin: 0,
                  }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseShivaiTravels;